import React from "react";
import "../Home/Home.css";
// import Header from "../Header/Header";
// import Footer from "../Footer/Footer";
import { motion as m } from "framer-motion";

const Blog3 = () => {
  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 0.5, 1] }}
      transition={{ duration: 0.9, ease: "easeIn" }}
      style={{ willChange: "opacity" }}
    >
      {/* <Header /> */}
      <div className="bg-white dark:bg-black dark:text-white transition-all duration-300 ease-in-out">
        {/* Banner */}
        <div className="px-5 lg:px-[7%] 2xl:px-[13%] py-10 pt-36 sm:pt-32">
          <div className="flex justify-center items-center py-5 w-full bg-gray-100 text-gray-900 dark:bg-neutral-800 border border-gray-100 dark:border-gray-800 text-left p-3 dark:text-gray-50 text-base font-bold rounded-lg transition-all duration-200 ease-in-out">
            <div className="grid grid-cols-1 sm:grid-cols-[200px_auto] gap-2 sm:gap-5 sm:justify-center w-full">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/a74e281a-2bf2-4313-b973-7a62ca56f100/public" //Init_Blog3.webp
                alt="Img"
                className="flex justify-end w-36 sm:w-48 -mt-10 sm:mt-0 sm:-mb-20 shadow-custom dark:shadow-white"
              />

              <p
                className="font-light capitalize mt-2 text-2xl lg:text-3xl transition-all duration-200 ease-in-out"
                style={{ lineHeight: 1.5 }}
              >
                Tech Trends 2024: <br />
                <span className="font-semibold">
                  How SaaS is changing <br className="hidden md:block" /> the
                  Software Industry
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="px-5 lg:px-[10%] 2xl:px-[15%] pt-0 pb-10 sm:py-10 space-y-6 text-justify">
          <p>
            The way we use software has changed dramatically with the rise of
            SaaS (Software as a Service). Instead of buying and installing
            software on individual computers, businesses and individuals now
            access powerful tools through the cloud. SaaS has revolutionized the
            software industry by offering a more flexible, scalable, and
            affordable solution.
          </p>

          <hr className="mx-5 border-t border-teal-500 dark:border-teal-600" />

          <div className="space-y-3">
            <p>1. Shift towards remote and hybrid work</p>
            <p>2. Enterprise-level tools</p>
            <p>3. Scalability</p>
          </div>

          <p>
            One of the main advantages of SaaS is its flexibility. Businesses no
            longer have to worry about hardware or complex installations. They
            can subscribe to the software they need, access it from anywhere,
            and pay only for what they use. This pay-as-you-go model helps
            companies save money and scale effortlessly as they grow.
          </p>

          <p>
            SaaS also keeps software up to date without manual updates.
            Providers handle updates and maintenance behind the scenes, ensuring
            businesses always have the latest features and security patches.
          </p>

          <p>
            At Init Technology, we are part of this revolution. We're excited to
            introduce two new SaaS products—Quotsync and Waverise Hub. Quotsync
            helps businesses streamline their quoting process, making it faster
            and more efficient. Waverise Hub, on the other hand, offers a
            comprehensive solution for project management and collaboration,
            ideal for teams of any size.
          </p>

          <p>
            In addition to these products, we specialize in creating custom
            solutions tailored to our clients' needs. Whether you require a
            unique feature or an entirely new platform, we can build it from the
            ground up to meet your business goals.
          </p>

          <p>
            In addition to these products, we specialize in creating custom
            solutions tailored to our clients' needs. Whether you require a
            unique feature or an entirely new platform, we can build it from the
            ground up to meet your business goals.
          </p>

          <br />
          <br />

          <div className="text-sm">
            <p className="font-semibold">Naju.K</p>
            <p>September 14, 2024 ∙ 4 mins read</p>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </m.div>
  );
};

export default Blog3;
